import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnInit, TrackByFunction } from '@angular/core'

import { combineLatest, map, mergeAll, mergeMap, Observable, take, toArray } from 'rxjs'
import { toObservable } from '@angular/core/rxjs-interop'
import { ContainersService } from '@appContent/shared/services/containers.service'
import { AppSignals, ContentRegistrationsService } from '@appShared/services'
import { IContainer } from '@appShared/interfaces/[Model-based]/container.interface'
import { Completion_ } from '@appShared/services/lookup/[CodeGen]/completion.domain'
import { ComponentType_ } from '@appShared/services/lookup/[CodeGen]/component-type.domain'
import { IProfile } from '@appShared/interfaces/[Model-based]/profile.interface'
import { environment } from '@appEnvironments/environment'

@Component({
    selector: 'app-lms-module-list',
    templateUrl: './module-list.component.html',
    styleUrls: ['./module-list.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class LmsModuleListComponent {
   @Input() title: string
   @Input() areaId: number
   @Input() moduleName: string
   @Input() isDashboardContext: boolean
   @Input() completionTypeCode?: Completion_
   @Input() componentTypeCode?: ComponentType_
   tenants: IContainer[] = []
   completionTypes = Completion_
   completedTokenModules: IContainer[] = []
   incompleteTokenModules: IContainer[] = []
   notStartedTokenModules: IContainer[] = []
   standardModules: IContainer[] = []
   isLoaded = false

   private _currentUser = inject(AppSignals).currentUser

   constructor(
      private _contentRegistrationsService: ContentRegistrationsService,
      private _containersService: ContainersService,
      private _cd: ChangeDetectorRef
   ) {
      this.title = this.title || 'Module List'

      let resolveModules = (): Observable<IContainer[]> => {

         const moduleCourseImagesUri = `${environment.publicCdn.uri}/${environment.publicCdn.moduleCourseImagesFolder}`

         return this._containersService.getPartitionsForTenant().pipe(
            take(1),
            mergeAll(),
            mergeMap((tenant: IContainer) =>
               this._contentRegistrationsService.getCourseRequestBody(tenant.info.encodedToken)
                  .pipe(
                     map((courseFormData) => {
                        if (!tenant.iconImageUri) {
                           const hostedContentToken = tenant.info.hostedContentToken
                           tenant['iconImageUri'] = hostedContentToken
                              ? `${moduleCourseImagesUri}/${hostedContentToken}.png` :
                              'https://via.placeholder.com/400x293' /*  TODO?? maybe different url if nothing there */
                        }

                        return ({ ...tenant, courseFormData })
                     })
                  )
            ),
            toArray()
         )
      }

      combineLatest([
         toObservable(this._currentUser),
         resolveModules()
      ])
         .pipe(take(1))
         .subscribe(([user, tenants]) => {

            this._createModuleLinks(tenants, user?.profile)

            this._cd.markForCheck()
         })
   }

   /*
   * private methods
   * */

   private _createModuleLinks(tenants: IContainer[], profile?: IProfile) {

      //todo for future use
      //let contentRegistrations = profile?.contact?.contentRegistrations || []

      this.tenants = [...tenants]

      this.isLoaded = true
   }

   /*
   * public methods
   * */

   trackByTenantId: TrackByFunction<IContainer> = (index, module) => module.id
}
